/**
 * Отображает индикатор загрузки внутри кнопки отправки формы и блокирует все поля ввода и кнопки на форме,
 * чтобы предотвратить повторную отправку во время обработки запроса.
 *
 * @param {string} text Текст, отображаемый рядом с индикатором загрузки.
 * @param {string} selector CSS-селектор кнопки, в которой будет отображаться индикатор.
 */
export function loading(text = 'Идёт расчёт, оставайтесь на странице...', selector = '#sendBtn') {
  let btnForSend = document.querySelector(selector);
  btnForSend.innerHTML = `<span class="spinner-border spinner-border-sm" role="status"></span> ${text}`;
  $('input').prop('readOnly', true);
  $('select').addClass('freeze-select');
  $('button').prop('disabled', true);
}

export function saveTempForm(data, path) {
  return sendData(data, path)
    .then(function (response) {
      const answer = response.answer;
      if (answer.answer != 'Ошибка') {
        alert('Успешно сохранено');
      } else {
        console.error('Ошибка при сохранении:', answer.answer);
      }
    })
    .catch(function (error) {
      console.error('Ошибка при сохранении:', error);
    });
}

export function removeWorkCalc(id) {
  if (confirm('Вы уверены?')) {
    fetch('/do/removeWorkCalc?workCalcId=' + id, {
      method: 'GET', // или 'POST', если сервер требует POST-запрос
      headers: {
        'Content-Type': 'application/json'
      }
    })
      .then((response) => {
        if (response.ok) {
          let currentUrl = new URL(window.location.href);

          window.location.href = currentUrl;

          if (currentUrl.searchParams.has('id')) {
            currentUrl.searchParams.delete('id');
          }

          if (window.location.href !== currentUrl.href) window.location.href = currentUrl.href;
          else window.reload;
        } else throw new Error('Произошла ошибка при удалении');
        return response;
      })
      .then((data) => {
        console.log(data); // Обработка полученных данных

        // Здесь можно добавить логику для обновления интерфейса пользователя, например, удалить элемент из списка
      })
      .catch((error) => {
        console.error('Ошибка:', error);
        alert('Произошла ошибка при удалении');
      });
  }
}
